(function () {
    'use strict';


    angular.module('swif.parcauto')
    .factory('swifParcautoService', swifParcautoService);


    function swifParcautoService($q, swif, swifParcautoConstant, openstc, patrimoine, swifOpenbaseCompanyService) {
        'ngInject';
        var patrimoine_contract = patrimoine.contract;
        var constant = swifParcautoConstant;
        var interventions = openstc;
        var service = angular.copy(constant);
        service.intervention = {};
        service.brand = {};
        service.fuel = {};
        service.type = {};
        service.model = {};
        service.automobile = {};
        service.request = {};
        service.planning = {};
        service.patrimoine = {};
        service.consumption = {};
        service.configuration = {};
        service.configuration.resolveData = function () {
            var data = {};
            return swif.route.check().then(function () {
                var promises = [];
                promises.push(service.brand.createCollection());
                promises.push(service.model.createCollection());
                promises.push(service.type.createCollection());
                promises.push(service.fuel.createCollection());
                return $q.all(promises).then(function (collections) {
                    data.brands = collections[0];
                    data.models = collections[1];
                    data.types = collections[2];
                    data.fuels = collections[3];
                    return data;
                });
            });
        };
        service.patrimoine.resolveReferentielData = function () {
            return swif.route.check({resources: ['d3', 'leaflet']}).then(function () {
                var data = {};
                data.title = 'Parc';
                data.actionViewsCategory = 'parcautoViews';
                data.patrimoine_type = 'patrimoine_equipment';

                var deferred = $q.defer();

                var filter = patrimoine.referentiel.getCollectionFilter(data.patrimoine_type);
                swif.data.addFilter(filter, 'categ_id.is_vehicle', '=', true);
                patrimoine.property.is_parcauto = true;
                patrimoine.referentiel.createCollection(data.patrimoine_type, filter)
                .then(function (collection) {
                    data.referentiel = collection;
                    patrimoine.referentiel.data.referentiel = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };
        // used for parc auto contracts but with the same collection as patrimoine contracts
        service.patrimoine.resolveContractsData = function () {
            return swif.route.check().then(function () {
                var deferred = $q.defer();
                var data = {};
                data.title = 'Controls-Contracts';
                var filter = {};
                swif.data.addExtraFilter(filter, 'is_parcauto', 'service_id.is_parcauto', '=', true);
                patrimoine_contract.createCollection(filter).then(function (collection) {
                    data.contracts = collection;
                    patrimoine.referentiel.data.contracts = collection;
                    deferred.resolve(data);
                });
                return deferred.promise;
            });
        };
        service.request.resolveData = function () {
            return swif.route.check().then(function () {
                var data = {};
                data.title = 'Demandes';
                data.actionViewsCategory = 'parcautoViews';
                data.preModal = service.request.preModal;
                data.callback = interventions.request.callback;
                data.preValidate = interventions.request.preValidate;

                var deferred = $q.defer();

                var filter = {};
                filter.fields = interventions.request.COLLECTION_FIELDS;
                //swif.data.addExtraFilter(filter, 'is_parcauto', 'equipment_id.categ_id.is_vehicle', '=', true);
                swif.data.addExtraFilter(filter, 'is_parcauto', '|');
                swif.data.addExtraFilter(filter, 'is_parcauto', 'service_id.is_parcauto', '=', true);
                swif.data.addExtraFilter(filter, 'is_parcauto', 'is_parcauto', '=', true);
                swif.data.sortOn(filter, 'id', 'DESC');

                swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {

                    var default_states = company.state_default_filters;
                    if (!default_states) {
                        default_states = ['valid', 'wait', 'to_confirm'];
                    }
                    swif.data.addFilter(filter, 'state', 'in', default_states);

                    swif.collections.createOrUpdate(
                        'requests',
                        'intervention_request',
                        filter
                    ).then(function (collection) {
                        data.requests = collection;
                        deferred.resolve(data);
                    });
                });

                return deferred.promise;
            });
        };
        service.request.preModal = function (data) {
            interventions.request.preModal(data);
            if (data.action.id === 'add') {
                data.model._display_equipment_id = true;
            }
        };
        service.consumption.resolveData = function () {
            return swif.route.check({resources: ['d3']}).then(function () {
                var filter;
                swif.data.addFilter(
                    filter, 'equipment_id.categ_id.is_vehicle', '=', true
                );
                return swif.collection.createOrUpdate(
                    'parcauto_consumptions',
                    'equipment_line',
                    filter
                ).then(function (collection) {
                    var data = {};
                    data.consumptions = collection;
                    data.title = 'Consommations de carburants';
                    return data;
                });
            });
        };
        service.consumption.getCollection = function () {
            return swif.collection.getCollection('parcauto_consumptions');
        };
        service.consumption.preModal = function (data) {
            var collection = service.consumption.getCollection();
            if (collection) {
                return collection.preModal(data);
            }
        };
        service.consumption.preValidate = function (data) {
            var collection = service.consumption.getCollection();
            if (collection) {
                return collection.preValidate(data);
            }
        };
        service.consumption.callback = function (error, data) {
            var collection = service.consumption.getCollection();
            if (collection) {
                return collection.callback(error, data);
            }
        };
        service.planning.resolveData = function () {
            return interventions.planning.resolveData();
        };
        service.intervention.resolveData = function () {
            return swif.route.check().then(function () {
                var data = {};
                data.title = 'Entretien';
                data.actionViewsCategory = 'parcautoViews';
                data.preModal = service.intervention.preModal;
                data.callback = interventions.intervention.callback;
                data.preValidate = interventions.intervention.preValidate;
                var filter = interventions.intervention.getFilter();
                swif.data.addExtraFilter(filter, 'is_parcauto', '|');
                swif.data.addExtraFilter(filter, 'is_parcauto', 'service_id.is_parcauto', '=', true);
                swif.data.addExtraFilter(filter, 'is_parcauto', 'ask_id.is_parcauto', '=', true);
                swif.data.sortOn(filter, 'id', 'DESC');
                return swif.collections.createOrUpdate(
                    'interventions',
                    'intervention',
                    filter
                ).then(function (collection) {
                    data.interventions = collection;
                    return data;
                });
            });


        };
        service.intervention.createCollections = function () {
            var filter = {};
            filter.fields = ['id', 'name', 'description', 'site1', 'site_details', 'service_id', 'manager_id', 'partner_id', 'partner_address', 'create_date', 'write_uid', 'state', 'actions'];
            swif.data.addFilter(filter, 'state', 'in', ['valid', 'wait', 'to_confirm', 'dst']);
            swif.data.addExtraFilter(filter, 'is_vehicle', 'equipment_id.categ_id.is_vehicle', '=', true);
            swif.data.sortOn(filter, 'id', 'DESC');
            var promises = [];
            promises.push(swif.collections.createOrUpdate(
                'requests',
                'intervention_request',
                filter
            ));
            filter = {};
            swif.data.addFilter(filter, 'state', 'in', ['open', 'scheduled', 'pending']);
            swif.data.addExtraFilter(filter, 'is_vehicle', 'equipment_id.categ_id.is_vehicle', '=', true);
            swif.data.sortOn(filter, 'id', 'DESC');
            promises.push(swif.collections.createOrUpdate(
                'interventions',
                'intervention',
                filter
            ));
            filter = {};
            swif.data.addFilter(
                filter,
                'state', 'in', ['draft', 'open']
            );
            swif.data.addExtraFilter(filter, 'is_vehicle', 'project_id.equipment_id.categ_id.is_vehicle', '=', true);
            swif.data.sortOn(filter, 'id', 'DESC');
            promises.push(swif.collections.createOrUpdate(
                'tasks',
                'task',
                filter
            ));
            return $q.all(promises);
        };
        service.brand.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                'parcauto-brand',
                'parcauto_brand',
                filter
            );
        };
        service.model.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                'parcauto-model',
                'parcauto_model',
                filter
            );
        };
        service.type.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                'parcauto-type',
                'parcauto_type',
                filter
            );
        };
        service.fuel.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                'parcauto-fuel',
                'parcauto_fuel',
                filter
            );
        };
        service.automobile.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                'parcauto-automobile',
                'parcauto_automobile',
                filter,
                {location: true}
            );
        };
        service.automobile.getDoneTasks = function (automobile) {
            var filter = {};
            swif.data.addFilter(filter, 'state', '=', 'done');
            if (automobile.equipment_id) {
                swif.data.addFilter(filter, 'project_id.equipment_id.id', '=', automobile.equipment_id[0]);
            }
            filter.fields = ['id', 'consumable_ids', 'consumable_cost', 'hr_cost', 'team_id', 'user_id', 'partner_id', 'equipment_cost'];
            return swif.data.get('task', undefined, filter);
        };
        service.automobile.getConsumablesByType = function (automobile) {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            filter.fields = ['id', 'name', 'complete_name', 'type_id'];
            swif.data.addFilter(filter, 'id', 'in', automobile.consumable_ids);
            return swif.data.groupRead('consumable', filter, ['type_id']);
        };
        service.automobile.getInterventionsSummary = function (automobile) {
            var deferred = $q.defer();
            var promises = [];
            var result = {};
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            swif.data.addFilter(filter, 'equipment_id.id', '=', automobile.equipment_id[0]);
            var getFilter = function (states) {
                var stateFilter = angular.copy(filter);
                swif.data.addFilter(stateFilter, 'state', 'in', states);
                return stateFilter;
            };
            promises.push(
                swif.data.getContentRange('intervention_request', getFilter(['finshed']))
            );
            promises.push(
                swif.data.getContentRange('intervention_request', getFilter(['valid', 'wait', 'to_confirm', 'dst']))
            );
            promises.push(
                swif.data.getContentRange('intervention', getFilter(['finished']))
            );
            promises.push(
                swif.data.getContentRange('intervention', getFilter(['open', 'scheduled', 'template', 'pending']))
            );
            filter.domain[0][0] = 'project_id.equipment_id.id';
            promises.push(
                swif.data.getContentRange('task', getFilter(['done']))
            );
            promises.push(
                swif.data.getContentRange('task', getFilter(['draft', 'open']))
            );
            promises.push(
                swif.data.groupRead('task', getFilter(['done']), ['category_id'])
            );
            promises.push(
                swif.data.groupRead('task', getFilter(['draft', 'open']), ['category_id'])
            );
            $q.all(promises).then(function (promises) {
                result = {
                    request: {
                        past: promises[0],
                        futur: promises[1]
                    },
                    intervention : {
                        past: promises[2],
                        futur: promises[3]
                    },
                    task : {
                        past: promises[4],
                        past_bycat: promises[6],
                        futur: promises[5],
                        futur_bycat: promises[7]
                    }
                };
                deferred.resolve(result);
            }, function (error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
        return service;
    }

})();
